import { render, staticRenderFns } from "./BinnacleHistory.vue?vue&type=template&id=6e62c1e2&scoped=true"
import script from "./BinnacleHistory.vue?vue&type=script&lang=js"
export * from "./BinnacleHistory.vue?vue&type=script&lang=js"
import style0 from "./BinnacleHistory.vue?vue&type=style&index=0&id=6e62c1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e62c1e2",
  null
  
)

export default component.exports